import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-background',
  templateUrl: './blank-background.component.html',
  styleUrls: ['./blank-background.component.scss']
})
export class BlankBackgroundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
